import React, { useState } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { Avatar, Box, Grid, Paper, Typography } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import { useStyles } from "./styles";
import { getUserInfo } from "../../../../../../utilities/storage";
import MessageDialog from "../../../../../../utilities/components/MessageDialog/MessageDialog";
import { APP_URLS } from "../../../../../../utilities/constants";
import moment from "moment";

/**
 * function to render case items
 * @param history: history from router
 * @param selectedDept: selected department
 * @param caseItem: case item details
 * @returns {JSX.Element}
 * @constructor
 */
const CaseItem = ({ history, selectedDept, caseItem }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const isDoctor = caseItem.Caregivers.find(
    (doctor) => doctor.id === getUserInfo().id
  );

  const doctorsList = caseItem.Caregivers.filter(
    (doctor) => doctor.id !== caseItem.createdById
  );

  /**
   * function to handle case item click
   */
  const handleCaseItemClick = () => {
    if (selectedDept && !selectedDept.headDoctor && !isDoctor) {
      setOpen(true);
    } else {
      history.push(`${APP_URLS.CASES}/${caseItem.id}`);
    }
  };

  const getInitials = (firstName = "", lastName = "") => {
    return `${firstName.charAt(0).toUpperCase()} ${lastName
      .charAt(0)
      .toUpperCase()}`;
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Box
          component={Paper}
          className={classes.contentContainer}
          onClick={handleCaseItemClick}
        >
          <Box className={classes.contentCard}>
            <Box className={classes.doctorListContainer}>
              <Box>
                <Typography
                  className={clsx(
                    classes.caseText,
                    caseItem.priority === 1 ? classes.caseTextCritical : ""
                  )}
                >
                  Case #{caseItem.id}
                </Typography>
              </Box>
              <Box className={classes.doctorsAvatarContainer}>
                <Box>
                  <Avatar className={classes.createdByAvatar}>
                    <span className={classes.createdByAvatarContent}>
                      {getInitials(
                        caseItem.createdByFirstName,
                        caseItem.createdByLastName
                      )}
                    </span>
                  </Avatar>
                </Box>
                {doctorsList.map((item, index) => (
                  <Box key={index}>
                    <Avatar className={classes.avatar}>
                      <span className={classes.doctorAvatarContent}>
                        {getInitials(item.firstname, item.lastname)}
                      </span>
                    </Avatar>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box>
              <Typography noWrap className={classes.descText}>
                {caseItem.desc}
              </Typography>
            </Box>
            <Box className={classes.cardFooter}>
              <Box>
                <Box className={classes.cardFooterCreatedBy}>
                  <Typography className={classes.createdByText}>
                    Created by:{" "}
                    {`${caseItem.createdByFirstName} ${caseItem.createdByLastName}`}
                  </Typography>
                </Box>

                <Box className={classes.cardFooterUpdatedOn}>
                  <Typography className={classes.createdByText}>
                    Updated on:{" "}
                    {moment(caseItem.updatedAt).format("DD/MM/YY [at] hh:mm a")}
                  </Typography>
                </Box>
              </Box>

              <Box>
                {selectedDept && !selectedDept.headDoctor && !isDoctor && (
                  <LockIcon className={classes.lockIcon} />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>

      <MessageDialog
        open={open}
        setOpen={setOpen}
        title="Sorry!"
        message="You do not have permission to view this case. Contact a case doctor to request permission."
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedDept: state.ayucareUsers.selectedDept,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseItem);
